export default "__VITE_ASSET__WEWe4njA__"